import {env} from '@baidu/boxx-fe';
import {UPDATE_TOAST} from './index';
export const {isIOS, isAndroid, isHarmonyOS, boxVersion, versionCompare, OSVersion, UA} = env;
// 为避免循环依赖，这里的逻辑从tools抽出来单写
const appVersionCompare = (version: string) => {
    if (isHarmonyOS) {
        return 1;
    }
    return versionCompare(boxVersion, version);
};
const v55 = appVersionCompare('5.5') >= 0;
const descName =  v55 ? '能量值' : '言粒';

// 风险控制相关的配置内容
const RISK_CONTROL_TIPKEY_MAP: {
    [key: string]: {[key: string]: string | number | object};
} = {
    // 会话即将达到上限
    'aboutLimit': {
        title: '快到对话上限啦',
        buttonTitle: '新建一个试试',
        buttonType: 'reset',
        chatDisable: 0,
    },
    // 4.0提问次数达到上限
    'askCountLimit': {
        title: '已达到文心大模型4.0版提问上限，稍后可继续使用',
        buttonTitle: '切换到文心大模型3.5版',
        toastMsg: '已达到文心大模型4.0版提问上限，稍后可继续使用',
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
    },
    'askCountLimitFullscreenVoice': {
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
        ext: {
            scene: 'uplimit',
        },
    },
    // session封禁
    'banSession': {
        title: '换个话题重新开始吧',
        buttonTitle: '新建对话',
        toastMsg: '换个话题重新开始吧',
        buttonType: 'reset',
        chatDisable: 1,
    },
    // prompt封禁
    'banPrompt': {
        title: '重置对话继续聊吧',
        toastMsg: '重置对话继续聊吧',
        buttonTitle: '重置',
        buttonType: 'reset',
        chatDisable: 1,
    },
    // 一言PCsession封禁
    'banYiyanSession': {
        title: '换个话题重新开始吧',
        toastMsg: '换个话题重新开始吧',
        chatDisable: 1,
    },
    // 角色下线
    'characterOffline': {
        title: '抱歉，该服务已经被下线，无法继续使用',
        toastMsg: '服务已下线',
        chatDisable: 1,
        ext: {
            resetToast: '服务已下线，无法重置',
        },
    },
    // 付费服务下线
    'payModeOffline': {
        title: '抱歉，该服务已下线',
        toastMsg: '抱歉，该服务已下线',
        chatDisable: 0,
    },
    // 4.0到期
    'expireModel': {
        title: '您的会员权益已到期，无法继续使用文心大模型4.0版',
        buttonTitle: '切换到文心大模型3.5版',
        toastMsg: '您的会员权益已到期，无法继续使用文心大模型4.0版',
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
    },
    'expireModelFullscreenVoice': {
        title: '您的会员权益已到期，无法继续使用文心大模型4.0版',
        buttonTitle: '切换到文心大模型3.5版',
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
        ext: {
            subTitle: '您的会员权益到期',
            subButtonTitle: '立即续费',
            scene: 'vip',
            scheme: 'baiduwanhua://newbrowse/detail?params=%7B%22url%22%3A%22https%3A%2F%2Fyiyanapp.baidu.com%2Ftalk%2Fvipcenter%22%7D',
        },
    },
    // 青春版会员
    'expireModelYoung': {
        title: '您的青春版会员权益已到期，无法继续使用文心大模型4.0版',
        buttonTitle: '切换到文心大模型3.5版',
        toastMsg: '您的青春版会员权益已到期，无法继续使用文心大模型4.0版',
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
    },
    'expireModelYoungFullscreen': {
        title: '您的青春版会员权益已到期，无法继续使用文心大模型4.0版',
        buttonTitle: '切换到文心大模型3.5版',
        toastMsg: '您的青春版会员权益已到期，无法继续使用文心大模型4.0版',
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
        ext: {
            subTitle: '您的青春版会员已到期，请选择',
            subButtonTitle: '解锁方式',
            scene: 'noCoin',
            // scene: 'vip',
            // scheme: 'baiduwanhua://newbrowse/detail?params=%7B%22url%22%3A%22https%3A%2F%2Fyiyanapp.baidu.com%2Ftalk%2Fvipcenter%22%7D',
        },
    },

    // prompt下线
    'promptOffline': {
        title: '抱歉，该服务已经被下线，无法继续使用',
        toastMsg: '服务已下线',
        chatDisable: 1,
        ext: {
            resetToast: '服务已下线，无法重置',
        },
    },
    // prompt不满足版本要求
    'needUpdate': {
        title: UPDATE_TOAST,
        buttonTitle: '去升级',
        toastMsg: UPDATE_TOAST,
        buttonType: 'update',
        chatDisable: 1,
        ext: {
            resetToast: UPDATE_TOAST,
        },
    },
    // 会话即将达到上限
    'upperLimit': {
        title: '抱歉，达到对话上限了',
        buttonTitle: '新建一个试试',
        toastMsg: '达到对话上限了，新建一个试试',
        buttonType: 'reset',
        chatDisable: 1,
    },
    'scheme': {
        title: 'scheme',
        toastMsg: 'scheme',
        buttonTitle: 'scheme',
        buttonType: 'scheme',
        chatDisable: 1,
        ext: {
            scheme: 'baiduwanhua://newbrowse/open?params=%7B%22share%22%3Afalse%2C%22type%22%3A%22landing%22%2C%22url%22%3A%22http%3A%2F%2Fwww.baidu.com%22%7D&callback=__boxx_2',
        },
    },
    'coinNotEnoughFullscreenVoice': {
        title: '',
        buttonTitle: '',
        buttonType: 'noCoin',
        chatDisable: 1,
        displayType: 1,
        ext: {
            subTitle: '您的灵感币余额不足',
            subButtonTitle: '立即获取',
            scene: 'coin',
            scheme: 'baiduwanhua://newbrowse/detail?params=%7B%22url%22%3A%22https%3A%2F%2Fyiyanapp.baidu.com%2Ftalk%2Fcointask%22%7D',
        },
    },
    'newCoinNotEnoughFullscreenVoice': {
        title: '',
        buttonTitle: '',
        buttonType: 'noCoin',
        chatDisable: 1,
        displayType: 1,
        ext: {
            subTitle: `您的${descName}余额不足`,
            subButtonTitle: '立即获取',
            scene: 'coin',
            scheme: 'baiduwanhua://newbrowse/detail?params=%7B%22url%22%3A%22https%3A%2F%2Fyiyanapp.baidu.com%2Ftalk%2Fgrowthcenter%22%7D',
        },
    },
    'coinDayPayOverdue': {
        chatDisable: 1,
        title: '特惠日卡已到期，请选择',
        buttonTitle: '解锁方式',
        buttonType: 'noCoin',
        displayType: 0,
        toastMsg: '请解锁后继续对话',
        ext: {
            subTitle: '特惠日卡已到期，请选择',
            subButtonTitle: '解锁方式',
            scene: 'dayCard',
        },
    },
    'youngVipToBasic': {
        displayType: 1,
        chatDisable: 1,
        title: '非青春版会员可用时段，请切换模型',
        buttonTitle: '切换为文心大模型3.5',
        buttonType: 'changeModel',
        toastMsg: '非青春版会员可用时段，请切换模型',
        ext: {
            scene: 'liteVip',
            availableTime: '',
            autoChangeToast: '非青春版会员可用时段，请切换模型',
        },
    },
    'youngVipToPro': {
        displayType: 1,
        chatDisable: 0,
        title: '当前为青春版会员可用时段，请切换模型',
        buttonTitle: '切换为文心大模型4.0',
        buttonType: 'changeModel',
        toastMsg: '当前为青春版会员可用时段，请切换模型',
        ext: {
            scene: 'liteVip',
            availableTime: '',
            autoChangeToast: '当前为青春版会员可用时段，已为你自动切换文心4.0模型',
        },
    },
    'secondChatToBasic': {
        displayType: 0,
        chatDisable: 1,
        title: '非青春版会员可用时段，请选择',
        buttonTitle: '解锁方式',
        buttonType: 'noCoin',
        toastMsg: '请解锁后继续对话',
        ext: {
            subTitle: '非青春版会员可用时段，请选择',
            subButtonTitle: '解锁方式',
            scene: 'noCoin',
        },
    },
    // 上屏时助手已下线
    'chatCharacterOffline': {
        buttonType: 'changeCharacter',
        displayType: 0,
        chatDisable: 1,
        toastMsg: '助手已下线，切换助手后继续使用',
        buttonTitle: '点击切换',
        title: '再见朋友，换个助手陪伴你吧',
    },
    // 上屏时话题已下线
    'chatTopicOffline': {
        title: '抱歉，该服务已经被下线，无法继续使用',
        toastMsg: '服务已下线',
        chatDisable: 1,
        ext: {
            resetToast: '服务已下线',
        },
    },
    // 多模页图片风控异常禁用输入框
    'multiPageImageError': {
        displayType: 0,
        chatDisable: 1,
        toastMsg: '',
        title: '',
        buttonTitle: '',
        buttonType: '',
    },
    'multiPageLiftRiskControl': {
        displayType: 0,
        chatDisable: 0,
        toastMsg: '',
        title: '',
        buttonTitle: '',
        buttonType: '',
    },
    // 会员免费异常
    'memberFreeError': {
        title: '4.0服务太火爆了，请切换模型',
        buttonTitle: '切换为文心大模型3.5版',
        toastMsg: '',
        buttonType: 'changeModel',
        chatDisable: 1,
        displayType: 1,
    },
};

export {RISK_CONTROL_TIPKEY_MAP};
